export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_car-hurt-help/artifacts/4m34v0ld_B0244CB9-28F2-4EB7-8C67-0F4E596266E6.png";

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1559493909-ee5feb0b298d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";

export const HANDSHAKE_IMAGE =
  "https://images.unsplash.com/photo-1638262052640-82e94d64664a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
